import { FC, useState } from 'react';
import { Button, TextField } from '@mui/material';
import StorylineServerProxy from "./storyline-proxy/storyline-proxy";

export interface PasswordChangerProps {
    username: string,
  }
  
  export const PasswordChanger:FC<PasswordChangerProps> = ({ username }) => {
    let [oldPassword, setOldPassword] = useState("");
    let [newPassword, setNewPassword] = useState("");
  
    function handleSubmit(){ 
      StorylineServerProxy.changePassword(username, oldPassword, newPassword).then((data) => {
        if(data.result){
          alert("Password changed successfully");
        }
        else{
          alert("Password changed failed");
        }
        setOldPassword("");
        setNewPassword("");
      });
    }
  
    return (
      <>
        <TextField label="Old password" type="password" onChange={(event) => { setOldPassword(event.target.value) }} value={oldPassword}></TextField>
        <TextField label="New password" type="password" onChange={(event) => { setNewPassword(event.target.value) }} value={newPassword}></TextField>
        <Button onClick={handleSubmit}>Submit</Button>
      </>
    )
  }
  